<template>
  <div id="app">
    <!-- Topbar and Navigation can stay global if you want them on every page -->
    <Topbar />
    <Navigation />

    <!-- This is where IndexPage, AboutPage, ServicesPage, etc. will load -->
    <router-view />

    <Test />
  </div>
</template>

<script>
import Topbar from '@/components/TopBarPage.vue'
import Navigation from '@/components/NavigationPage.vue'
import Test from '../src/layouts/TestPage.vue'

export default {
  name: 'App',
  components: { Topbar, Navigation, Test }
}
</script>
